import { createAction } from "redux-actions";

const prefix = "ADMIN_MENU_";

export class Constants {
    public static IS_OPEN = prefix + "IS_OPEN";
}

export const toggleOpen = createAction<boolean, boolean>(
    Constants.IS_OPEN, (isOpen) => (isOpen),
);



// WEBPACK FOOTER //
// ./src/actions/AdminMenuActions.ts